module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.761/img/favicon-dark.png"